/* Cité Érotik — predictive search Web Component */
(function () {
  'use strict';

  function money(cents) {
    return (window.theme && theme.formatMoney) ? theme.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      if (!this.input || !this.results) return;

      this.timer = null;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(), 250);
      });
    }

    async search() {
      var q = this.input.value.trim();
      if (q.length < 2) { this.results.hidden = true; this.results.innerHTML = ''; return; }

      try {
        var base = (window.theme && theme.routes.predictiveSearch) || '/search/suggest';
        var url = base + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        var res = await fetch(url);
        var data = await res.json();
        this.render(data.resources.results.products || [], q);
      } catch (err) {
        this.results.hidden = true;
      }
    }

    render(products, q) {
      if (!products.length) {
        this.results.innerHTML = '<p class="p-4 text-on-surface-variant text-sm">No results found.</p>';
        this.results.hidden = false;
        return;
      }
      var html = '<ul class="divide-y divide-outline-variant">';
      products.forEach((p) => {
        var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
        html +=
          '<li><a href="' + p.url + '" class="flex items-center gap-3 p-3 hover:bg-on-surface/5 rounded-md">' +
            (img ? '<img src="' + img + '" alt="" width="48" height="48" class="w-12 h-12 object-cover rounded bg-surface-container">' : '') +
            '<span class="flex-1 min-w-0"><span class="block text-sm font-medium text-on-surface truncate">' + p.title + '</span>' +
            (p.price ? '<span class="block text-sm text-on-surface-variant">' + money(parseFloat(p.price) * 100) + '</span>' : '') +
            '</span></a></li>';
      });
      html += '</ul>';
      html += '<a href="' + ((window.theme && theme.routes.root) || '/') + 'search?q=' + encodeURIComponent(q) + '" class="block p-3 text-center text-primary text-sm font-medium hover:bg-on-surface/5">View all results</a>';
      this.results.innerHTML = html;
      this.results.hidden = false;
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
})();
